import {
    router
} from './main'

class API {

    static cadastro = '/api/auth/cadastro';
    static login = '/api/auth/login';
    static refreshToken = '/api/auth/refreshToken';
    static usuario = '/api/controleacesso/usuarios';
    static sistema_id = 11;
    static menu_obra_id = 6;
    static menu_cadastro_id = 7;
    static sistemas = [];
    static req;
    static lock = false;

    // em caso de requisições get com headers, estes deverão ser declarados no array de dados
    static enviarRequisicao = function (metodo, url, dados = {}, headers = {}) {
        return new Promise((resolve, reject) => {
            $('.carregando').removeClass('d-none');

            axios[metodo](url, dados, headers).then(resp => {
                $('.carregando').addClass('d-none');
                resolve(resp);
                if(API.lock)
                    API.lock = false
            }).catch(async function (erro) {
                $('.carregando').addClass('d-none');
                if (erro.response.status == 401) {
                    if (!API.lock) {
                        API.lock = true;
                        API.req = store.dispatch('refreshToken').then(function (resp) {
                            if (!resp.erro) {
                                resolve(API.enviarRequisicao(metodo, url, dados, headers));
                            } else {
                                if(resp.conflitoLogin) localStorage.conflitoLogin = true;
                                window.location.replace('/login');
                            }
                        });
                    }else{
                        await API.req;
                        resolve(api.enviarRequisicao(metodo, url, dados, headers));
                    }
                } else if (erro.response.status == 304) {
                    reject(erro);
                } else {
                    reject(erro);
                }
            });
        })
    };

    static geraNovoTokenDatatable = function (req) {
        if (req.status == 401) {
            Store.dispatch('atualizaToken').then(function (resp) {
                if (!resp.erro) {
                    window.location.reload();
                } else {
                    window.location.replace('/login');
                }
            });
        }
    };
}

export default API
